import { API_URL } from "env";

import { mixLogOut } from '../services/mixin';
export interface ChannelConnectionItem {
    id: number;
    channel_type_code: string;
    oauth_account_id: number;
    external_id: string;
    display_name: string;
    avatar_url: string;
    status: number;
    total_channel_customers: number;
    created_by_id: number;
    created_at: string;
    updated_at: string;
    creator: {
        id: number;
        email: string;
        fullname: string;
    };
    oauth_account: {
        id: number;
        provider: string;
    };
}

export interface ChannelConnectionListResponse {
    status: boolean;
    data: {
        total: number;
        current_page: number;
        items: ChannelConnectionItem[];
    } | null;
}

export async function getChannelConnections(params?: {
    search?: string;
    channel_type_code?: string;
    status?: number;
    page?: number;
    limit?: number;
}): Promise<ChannelConnectionListResponse> {
    try {
        const token = localStorage.getItem('token') || '';
        const query = new URLSearchParams();
        if (params?.search) query.append('search', params.search);
        if (params?.channel_type_code) query.append('channel_type_code', params.channel_type_code);
        if (params?.status !== undefined) query.append('status', String(params.status));
        if (params?.page) query.append('page', String(params.page));
        if (params?.limit) query.append('limit', String(params.limit));
        const queryString = query.toString();

        const response = await fetch(`${API_URL}/api/v1/be/channel-connections${queryString ? `?${queryString}` : ''}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            if (response.status === 401) { mixLogOut(); }
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json() as ChannelConnectionListResponse;
    } catch (error) {
        console.error('Failed to fetch channel connections:', error);
        return {
            status: false,
            data: null,
        };
    }
}

export interface ChannelConnectionDetailResponse {
    status: boolean;
    data: ChannelConnectionItem | null;
}

export async function getChannelConnectionById(id: number): Promise<ChannelConnectionDetailResponse> {
    try {
        const token = localStorage.getItem('token') || '';
        const response = await fetch(`${API_URL}/api/v1/be/channel-connection/${id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            if (response.status === 401) { mixLogOut(); }
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json() as ChannelConnectionDetailResponse;
    } catch (error) {
        console.error('Failed to fetch channel connection detail:', error);
        return {
            status: false,
            data: null,
        };
    }
}
